<div class="section instructions p-0">
  <h5 class="instructions-title p-0">{{ task.instructionsTitle }}</h5>
  <p [innerHTML]="task.instructions"></p>
</div>

<div
  class="card shadow-sm mb-3"
  *ngIf="
    task.content.consultantDisplayName &&
    (task.content.consultantAddress1 || task.content.consultantPhoneNumber)
  "
>
  <div class="m-3">
    <h4>{{ task.content.consultantDisplayName }}</h4>
    <h4>{{ task.content.consultantFacilityName }}</h4>
    <p class="font-weight-bold mb-1">{{ task.content.consultantSpecialtyName }}</p>
    <a
      href="https://www.google.com/maps/search/?api=1&query={{
        task.content.consultantLatitude
      }}, {{ task.content.consultantLongitude }}"
    >
      <p class="m-0 font-weight-bold">{{ task.content.consultantAddress1 }}</p>
      <p class="m-0 font-weight-bold">{{ task.content.consultantAddress2 }}</p>
      <p class="m-0 font-weight-bold">
        {{ task.content.consultantCity }}, {{ task.content.consultantState }}
        {{ task.content.consultantZip }}
      </p>
    </a>
    <a
      class="d-block d-md-none"
      *ngIf="task.content.consultantPhoneNumber"
      href="tel:{{ task.content.consultantPhoneNumber }}"
      ><button class="btn btn-lg btn-primary btn-block mb-3 mt-3">
        <p class="m-0 font-weight-bold">{{ task.content.consultantPhoneNumber }}</p>
      </button>
    </a>
    <span class="d-md-block d-none">
      <p class="m-0 font-weight-bold">{{ task.content.consultantPhoneNumber }}</p>
    </span>
  </div>
</div>

<div>
  <h5>{{ task.taskOptionsTitle }}</h5>
  <p>{{ task.taskOptionsDescription }}</p>
</div>
